import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { or, PrivateRoute, Roles } from '@/js/libs/use-auth';

import RoleBasedRedirector, { type Condition } from 'src/components/RoleBasedRedirector';
import { AnalogOperations } from 'src/scenes/AnalogOperations';
import Status from 'src/scenes/Status';

const homeConditions: Condition[] = [
  { roles: Roles.POSTNETZ, to: '/analog-operations/campaign-management' },
  { roles: Roles.POSTNETZ_BRANCH_USER, to: '/analog-operations/inventory-management' },
];

const index = true;

export const analogOperationsRouteObject = inferRouteObject({
  path: 'analog-operations',
  element: <PrivateRoute roles={or(Roles.POSTNETZ, Roles.POSTNETZ_BRANCH_USER)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: AnalogOperations.Helmet,
      children: [
        {
          index,
          element: <RoleBasedRedirector conditions={homeConditions} noAccessElement={<Status.NotFound />} />,
        },
        {
          path: 'campaign-management',
          element: (
            <PrivateRoute roles={Roles.POSTNETZ} noAccessComponent={Status.NotFound}>
              <AnalogOperations.CampaignManagement />
            </PrivateRoute>
          ),
          children: [{ index, Component: AnalogOperations.CampaignManagement }],
        },
        {
          path: 'inventory-management',
          children: [
            {
              element: <AnalogOperations.InventoryManagement.Layout />,
              children: [
                {
                  path: 'stock',
                  Component: AnalogOperations.InventoryManagement.Stock,
                },
                {
                  path: 'dispatch',
                  element: <PrivateRoute roles={Roles.POSTNETZ} noAccessComponent={Status.NotFound} />,
                  children: [
                    {
                      element: <AnalogOperations.InventoryManagement.Dispatch.Layout />,
                      children: [
                        {
                          path: ':state',
                          Component: AnalogOperations.InventoryManagement.Dispatch.New,
                        },
                      ],
                    },
                  ],
                },
                {
                  index,
                  element: <Navigate to='./stock' replace />,
                },
              ],
            },
            {
              path: 'send-dispatch',
              element: (
                <PrivateRoute roles={Roles.POSTNETZ} noAccessComponent={Status.NotFound}>
                  <AnalogOperations.InventoryManagement.SendDispatch.Layout />
                </PrivateRoute>
              ),
              children: [
                {
                  path: ':ids',
                  Component: AnalogOperations.InventoryManagement.SendDispatch.Form,
                },
                {
                  index,
                  element: <Navigate to='../dispatch' replace />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
